import { Component } from '@angular/core';

import {
    Animations,
    BackendOberflaecheService,
    BausteinBeitrag,
    BeitragComponent,
    OberflaecheSeite,
} from '@vhv/tarifrechner-common';


@Component({
    animations: [Animations.slideInDownAnimation],
    templateUrl: 'cyber-beitrag.component.html',
})
export class CyberBeitragComponent extends BeitragComponent {

    constructor(
        private _inputBackendOberflaecheService: BackendOberflaecheService,
    ) {
        super();
    }

    initialiseSeite() {
        this._inputBackendOberflaecheService.getOberflaeche().then((value: OberflaecheSeite[]) => {
            this._inputBackendOberflaecheService.getElementByName('Zahlweise').value = '1';
            super.initialiseSeite();
        });

    }

    getBausteine(): Map<string, BausteinBeitrag> {
        if (!this.beitragsdaten.getValue()) {
            return new Map<string, BausteinBeitrag>();
        }

        const result: Map<string, BausteinBeitrag> = new Map(this.beitragsdaten.getValue().beitraegeFuerBausteine);
        result.delete('Grundbaustein');

        return result;
    }

    getBausteinBezeichnungen(bausteinKey: string): string {
        const bausteinElement = this._inputBackendOberflaecheService.getElementByName('Baustein' + bausteinKey);

        if (bausteinElement) {
            return bausteinElement.attribut.label
        }

        return '';
    }

}
